import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
                爱妻艺找回
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                专为已婚男性打造的专业情感挽回平台，帮助你系统学习沟通技巧、重建信任、修复婚姻裂痕。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                文章分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    服务条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2.5 text-sm text-background-400">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-0.5"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5"></i>
                  <span>contact@aiqiyi-zhaihui.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 爱妻艺找回 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}